export const ClientModel = {
    name: '',
    owner: '',
    id: '',
    updated: {},
    created: {},
}